import { ThemeColors } from '@octopus-do/octopus-storybook'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

type Props = {
  children?: React.ReactNode
}

const Theme: React.FC<Props> = ({ children = null }) => {
  const theme = useSelector(migrationProjectSelector.getProjectTheme)

  useEffect(() => {
    const themeClass = ThemeColors[theme]
    const modifierClass = `--theme-${theme}`

    document.body.classList.forEach((cls) => {
      if (cls.startsWith('--theme-')) {
        document.body.classList.remove(cls)
      }

      if (Object.values(ThemeColors).includes(cls)) {
        document.body.classList.remove(cls)
      }
    })

    document.body.classList.add(themeClass, modifierClass)

    return () => {
      document.body.classList.remove(themeClass, modifierClass)
    }
  }, [theme])

  if (children) {
    return <>{children}</>
  }

  return null
}

export default Theme
